<template>
  <div>
    <div class="row">
      <div class="col-sm mt-4">
        <section-title
          icon="fa fa-clipboard-list-check"
          title="Resumen de Información General"
          title-class="font-14"
        />
        <detail-general-info-panel
          content="Total de Egreso"
          :count="summary.totalExitCount"
          :has-badge="false"
          image="eden-egreso-total.svg"
        />
        <detail-general-info-panel
          content="Diferencia año anterior"
          :count="summary.lastYearDifferenceCount"
          :has-badge="true"
          :badge-percent="computePercentage"
          image="eden-egreso-dif-anio-anterior.svg"
        />
      </div>
      <div class="col-md-9 mt-4">
        <section-title
          icon="fa fa-clipboard-list-check"
          title="Alertas"
          title-class="font-14"
        />
        <div class="row mt-3 px-3">
          <detail-alert
            content="Graduado con Diploma de Escuela Superior con menos de 15 años de edad."
            :count="summary.graduateWithDiplomaCounter.count"
            :has-button="summary.graduateWithDiplomaCounter.count > 0 && !readonly"
            button-text="Ejecutar"
            button-container-class="mt-2 execute-button"
            @click="
              executeAlert(
                summary.graduateWithDiplomaCounter.edenDataValidationErrorId
              )
            "
          />
          <detail-alert
            content="Recibido Certificado con menos de 15 años de edad."
            :count="summary.receivedCertificateCounter.count"
            :has-button="summary.receivedCertificateCounter.count > 0 && !readonly"
            button-text="Ejecutar"
            button-container-class="mt-2 execute-button"
            @click="
              executeAlert(
                summary.receivedCertificateCounter.edenDataValidationErrorId
              )
            "
          />
          <detail-alert
            content="Alcanzado edad máxima con menos de 20 años de edad."
            :count="summary.reachedMaximumAgeCounter.count"
            :has-button="summary.reachedMaximumAgeCounter.count > 0  && !readonly"
            button-text="Ejecutar"
            button-container-class="mt-2 execute-button"
            @click="
              executeAlert(
                summary.reachedMaximumAgeCounter.edenDataValidationErrorId
              )
            "
          />
        </div>
      </div>
    </div>
    <detail-snapshot      
      title="Detalle de Egreso"
      :filter-manager-config="filterManagerConfig" 
      :filters="filters"
      :data="resultData"
      :paging-list="pagingList"
      :page-size="pageSize"
      :page-size-mobile="pageSizeMobile"
      @on-search="onHandlerSearch"
      @on-change-page="goToPageHandler($event)"
      @on-selected-paging="onSelectedPagingHandler($event)"
      @on-print="{}">
      
       <div v-for="(row, idx) of resultData.result" :key="`result-${idx}`" class="py-1">
          <component :is="resultRow_component" :data="row" class="mb-3"></component>                      
       </div>       
    </detail-snapshot>
  </div>
</template>

<script>
import DetailAlert from "./DetailAlert.vue";
import DetailGeneralInfoPanel from "@/views/eden/shared/components/DetailGeneralInfoPanel.vue";
import Service from "@/services/api/edenexit.api";
import DetailSnapshot from "../../shared/components/DetailSnapshot.vue";
import SectionTitle from "SectionTitle";
import ResultRowDetail from "../../exit/components/ResultRowDetail.vue";

export default {
  name: "EdenDetails",
  components: {
    DetailAlert,
    DetailGeneralInfoPanel,
    DetailSnapshot,
    SectionTitle,
    ResultRowDetail
  },
  inject: ['mediaQueries'],
  props: {
    readonly:{
      type:Boolean,
      default: false,
    },
    collections: {
      type: Object,
      default: () => ({
        exitTypes: [],
        ethnicGroups: [],
        ages: [],
        genders: [],
        impediments: [],
        languagesProficiency: [],
        alerts: [],
      }),
    },
    summary: {
      type: Object,
      default: () => ({
        totalExitCount: 0,
        lastYearDifferenceCount: 0,
        graduateWithDiplomaCounter: {
          count: 0,
        },
        receivedCertificateCounter: {
          count: 0,
        },
        reachedMaximumAgeCounter: {
          count: 0,
        },
      }),
    },
  },
  data: () => ({
    resultRow_component: 'ResultRowDetail',
    info: {
      id: null,
      academicYear: null,
      statusName: null,
      lastUpdatedDate: null,
    },
    filters: {
        exitType: null,
        ethnicGroup: null,
        age: null,
        gender: null,
        impediment: null,
        languageProficiency: null,
        edenDataValidationError: null,
        studentSieId: null
    },  
    resultData: {
      result: {},
      pagination: {},
      selectedPaging: null
    }     
  }),  
  computed: {
    pageSize(){
      return 20;
    },
    pageSizeMobile(){
      return 5;
    },
    filterManagerConfig() {
      return [
      {
        name: 'exitType',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Tipo de Egreso:',
        placeholder: 'Seleccione',       
        class: "col-12 col-md-3",
        clearable: true,        
        options: this.collections.exitTypes,
        value: this.filters.exitType,
        disabled: this.collections.exitTypes.length <= 0,
      },
      {
        name: 'ethnicGroup',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Grupo Étnico:',
        placeholder: 'Seleccione',
        clearable: true,
        class: "col-12 col-md-3",
        options: this.collections.ethnicGroups,
        value: this.filters.ethnicGroup,
        disabled: this.collections.ethnicGroups.length <= 0,
      },
      {
        name: 'age',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',        
        label: 'Edad:',
        placeholder: 'Seleccione',
        clearable: true,
        class: "col-12 col-md-3",
        options: this.collections.ages,
        value: this.filters.age,
        disabled: this.collections.ages.length <= 0,
      },
      {
        name: 'gender',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Género:',
        placeholder: 'Seleccione',
        clearable: true,
        class: "col-12 col-md-3",
        options: this.collections.genders,
        value: this.filters.gender,
        disabled: this.collections.genders.length <= 0,
      },
      {
        name: 'impediment',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Impedimento:',
        placeholder: 'Seleccione',
        clearable: true,
        class: "col-12 col-md-3",
        options: this.collections.impediments,
        value: this.filters.impediment,
        disabled: this.collections.impediments.length <= 0,
      },
      {
        name: 'languageProficiency',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Aprendices del Español:',
        placeholder: 'Seleccione',
        clearable: true,
        class: "col-12 col-md-3",
        options: this.collections.languagesProficiency,
        value: this.filters.languageProficiency,
        disabled: this.collections.languagesProficiency.length <= 0,
      },
      {
        name: 'edenDataValidationError',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Alertas:',
        placeholder: 'Seleccione',
        clearable: true,
        class: "col-12 col-md-3",
        options: this.collections.alerts,
        value: this.filters.edenDataValidationError,
        disabled: this.collections.alerts.length <= 0,
      },
      {
        name: 'studentSieId',
        label: 'SIE:',
        component: 'CustomInput',               
        class: "col-12 col-md-3",
        value: this.filters.studentSieId,
        placeholder: 'Escriba número de SIE',
        type:'number'        
      },
    ]},
    pagingList() {
      return [      
        {
          id: 20,
          name: 20,
        },
        {
          id: 40,
          name: 40,
        },
        {
          id: 60,
          name: 60,
        },
        {
          id: 80,
          name: 80,
        },
        {
          id: 100,
          name: 100,
        }
      ];
    },   
    computePercentage() {
      if (
        this.summary.totalExitCount === 0 ||
        this.summary.lastYearDifferenceCount === 0
      )
        return 0;

      let difference = Math.abs(
        this.summary.lastYearDifferenceCount - this.summary.totalExitCount
      );

      let maxValue = Math.max(
        this.summary.lastYearDifferenceCount,
        this.summary.totalExitCount
      );

      return Math.floor(Math.abs((difference * 100) / maxValue));
    },
  },
  watch:{
    mediaQueries:{
      immediate: true,
      async handler(){        
        if(this.mediaQueries.mobile)
        {
          this.resultData.pagination.pageSize = this.pageSizeMobile;
          this.$emit('on-search');          
          return;
        }
        this.resultData.pagination.pageSize = this.pageSize
      }
    }
  },  
  async mounted(){    
    //set default paging
    if (!this.resultData.selectedPaging) {      
      this.resultData.selectedPaging = this.pagingList.find((x) => x.id == this.pageSize);      
    }
    await this.searchDetail();    
  }, 
  methods: {
    async onHandlerSearch(){
      this.resultData.pagination.currentPage = 1;                 
      await this.searchDetail();
    },   
    async goToPageHandler(page) {
      this.resultData.pagination.currentPage = page;
      await this.searchDetail();
    }, 
    async onSelectedPagingHandler(pageSize) {      
      if (pageSize) {
        this.resultData.pagination.currentPage = 1;      
        this.resultData.pagination.pageSize = pageSize;
        await this.searchDetail();
      }
    },
    async searchDetail()
    {            
      const params = {
        edenMasterId: new Number(this.$route.params.id),
        exitTypeId: this.filters.exitType?.id,
        ethnicGroupId: this.filters.ethnicGroup?.id,
        age: this.filters.age?.id,
        genderId: this.filters.gender?.id,
        impedimentId: this.filters.impediment?.id,
        languageProficiency: this.filters.languageProficiency?.id,
        edenDataValidationErrorId: this.filters.edenDataValidationError?.id,
        studentSieId: this.filters.studentSieId && new Number(this.filters.studentSieId),      
        pageIndex: this.resultData.pagination.currentPage,
        pageSize: this.resultData.pagination.pageSize
      };          

      await Service.searchDetail(params).then(({ data }) => {         
        this.resultData = {
        ...this.resultData,
        result: data.data,
        pagination:{
            ...this.resultData.pagination,
            totalItemCount: data.totalItemCount,
            pageCount: data.pageCount,
            currentPage: data.currentPage,
            count: data.count,
            pageSize: this.resultData.pagination.pageSize
          },        
        };
      });
    },   
    async executeAlert(edenDataValidationErrorId) {
      const result = await this.ShowCancelModal(
        "Atención",
        "¿Está seguro que desea actualizar los datos de la alerta?",
        "Sí",
        "No"
      );
      if (result) {
        const { data } = await Service.executealert(
          this.$route.params.id,
          edenDataValidationErrorId
        );
        if (data) {
          this.$emit("on-get-detail");
          this.ShowToast(
            "Confirmación",
            "Los datos de la alerta han sido actualizados exitosamente.",
            "success"
          );
        }
      }
    },
  },
};
</script>
